<template>
    <Pill :background="pillBackground">
        {{ pillText }}
    </Pill>
</template>
<script>
import Pill from 'components/Basic/Misc/Pill.vue';
import {
    pink,
    lightBlue,
    yellow,
    teal,
    positive,
    grey100
} from 'style/_gradients.scss';

export default {
    name: 'RPResponsePill',
    components: {
        Pill
    },
    props: {
        status: {
            type: String,
            default: 'unpublished',
            validator: val => [
                'unpublished',
                'pending',
                'closed',
                'on hold',
                'approved',
                'rejected',
                'posted',
            ].indexOf(val) !== -1
        },
    },
    computed: {
        pillText(){
            switch(this.status) {
            case 'unpublished':
                return 'Needs Response';
            case 'pending':
                return 'Needs Approval';
            case 'on hold':
                return 'On Hold';
            case 'approved':
                return 'Approved';
            case 'closed':
                return 'Closed';
            case 'posted':
                return 'Posted';
            default:
                return 'placeholder';
            }
        },
        pillBackground(){
            let background;
            switch(this.status) {
            case 'unpublished':
                background = pink;
                break;
            case 'pending':
                background = lightBlue;
                break;
            case 'on hold':
                background = yellow;
                break;
            case 'approved':
                background = teal;
                break;
            case 'posted':
                background = positive;
                break;
            case 'closed':
                background = grey100;
                break;
            default:
                background = 'transparent';
                break;
            }
            return {background};
        }
    }

};
</script>

<docs>
    ```vue
    <RPResponsePill status="unpublished"></RPResponsePill>
    <br>
    <RPResponsePill status="pending"></RPResponsePill>
    <br>
    <RPResponsePill status="on hold"></RPResponsePill>
    <br>
    <RPResponsePill status="approved"></RPResponsePill>
    <br>
    <RPResponsePill status="posted"></RPResponsePill>
    ```
</docs>

